export class TitleBlockAddBorders {
  constructor(borderContainer) {
    this.borderContainer = borderContainer;
  }

  addBorders() {
    this._createBorder(
      "top",
      "5px",
      "5px",
      "calc(100% - 10px)",
      "0",
      "borderTop",
      3
    );
    this._createBorder(
      "left",
      "5px",
      "5px",
      "0",
      "calc(100% - 10px)",
      "borderLeft",
      3
    );
    this._createBorder(
      "bottom",
      "calc(100% - 5px)",
      "5px",
      "calc(100% - 10px)",
      "0",
      "borderBottom",
      3
    );
    this._createBorder(
      "right",
      "5px",
      "calc(100% - 5px)",
      "0",
      "calc(100% - 10px)",
      "borderRight",
      3
    );

    this._createBorder(
      "top",
      "82%",
      "60%",
      "calc((100% - 10px) * 0.4)",
      "0",
      "borderTop",
      2
    );
    this._createBorder(
      "left",
      "82%",
      "60%",
      "0",
      "calc((100% - 10px) * 0.18)",
      "borderLeft",
      2
    );

    this._createBorder(
      "left",
      "82%",
      "75%",
      "0",
      "calc((100% - 10px) * 0.18)",
      "borderLeft",
      2
    );
    this._createBorder("top", "92%", "60%", "15%", "0", "borderTop", 2);

    this._createBorder("top", "83.66667%", "60%", "15%", "0", "borderTop", 1);
    this._createBorder("top", "85.33334%", "60%", "15%", "0", "borderTop", 1);
    this._createBorder("top", "87.00001%", "60%", "15%", "0", "borderTop", 1);
    this._createBorder("top", "88.66668%", "60%", "15%", "0", "borderTop", 1);
    this._createBorder("top", "90.33335%", "60%", "15%", "0", "borderTop", 1);
    this._createBorder("left", "82%", "65%", "0", "10%", "borderLeft", 1);
    this._createBorder("left", "82%", "70%", "0", "10%", "borderLeft", 1);
    this._createText("NAME", "82.33333%", "65.5%", "0.8vh", "left");
    this._createText("DATE", "82.33333%", "70.5%", "0.8vh", "left");
    this._createText("DRAWN", "84%", "60.5%", "0.8vh", "left");
    this._createText("CHECKED", "85.66667%", "60.5%", "0.8vh", "left");
    this._createText("ENG. APPR.", "87.33334%", "60.5%", "0.8vh", "left");
    this._createText("MFG. APPR.", "89.00001%", "60.5%", "0.8vh", "left");
    this._createText("Q.A.", "90.66668%", "60.5%", "0.8vh", "left");
    this._createText("", "84%", "65.5%", "0.8vh", "left", "drawnName");
    this._createText("", "84%", "70.5%", "0.8vh", "left", "drawnDate");
    this._createText("", "85.66667%", "65.5%", "0.8vh", "left", "checkedName");
    this._createText("", "85.66667%", "70.5%", "0.8vh", "left", "checkedDate");
    this._createText("", "87.33334%", "65.5%", "0.8vh", "left", "engApprName");
    this._createText("", "87.33334%", "70.5%", "0.8vh", "left", "engApprDate");
    this._createText("", "89.00001%", "65.5%", "0.8vh", "left", "mfgApprName");
    this._createText("", "89.00001%", "70.5%", "0.8vh", "left", "mfgApprDate");
    this._createText("", "90.66668%", "65.5%", "0.8vh", "left", "qaName");
    this._createText("", "90.66668%", "70.5%", "0.8vh", "left", "qaDate");
    this._createText("", "93%", "61%", "0.8vh", "left", "noteGrid");
    this._createText("", "84%", "75.5%", "0.8vh", "left", "companyGrid");
    this._createText("", "87.5%", "75.5%", "0.8vh", "left", "titleGrid");
    this._createText("", "94.5%", "84%", "2vh", "center", "dwgNo");
    this._createText("", "94.5%", "95.5%", "2vh", "center", "rev");

    this._createBorder(
      "top",
      "85.5%",
      "75%",
      "calc(25% - 5px)",
      "0",
      "borderTop",
      1
    );
    this._createBorder(
      "top",
      "91.5%",
      "75%",
      "calc(25% - 5px)",
      "0",
      "borderTop",
      1
    );
    this._createBorder("left", "91.5%", "80%", "0", "8%", "borderLeft", 1);
    this._createBorder("left", "91.5%", "94.5%", "0", "8%", "borderLeft", 1);
    this._createText("COMPANY", "82.33333%", "75.5%", "0.8vh", "left");
    this._createText("TITLE", "85.83333%", "75.5%", "0.8vh", "left");
    this._createText("SIZE", "91.83333%", "75.5%", "0.8vh", "left");
    this._createText("A", "94.5%", "77%", "2vh", "center");
    this._createText("DWG. NO.", "91.83333%", "80.5%", "0.8vh", "left");
    this._createText("REV", "91.83333%", "95%", "0.8vh", "left");

    this._createText("Powered by X-Microwave", "96.5%", "1.5%", "1.7vh", "left");
  }

  _createBorder(position, top, left, width, height, borderProperty, lineWidth) {
    const border = document.createElement("div");
    border.style.position = "absolute";
    border.style.top = top;
    border.style.left = left;
    border.style.width = width;
    border.style.height = height;
    border.style[borderProperty] = `${lineWidth}px solid black`;
    this.borderContainer.appendChild(border);
  }

  _createText(content, top, left, fontSize, align, id) {
    const textElement = document.createElement("div");
    textElement.style.position = "absolute";
    textElement.style.top = top;
    textElement.style.left = left;
    textElement.style.fontSize = fontSize;
    textElement.style.textAlign = align;
    textElement.innerText = content;
    textElement.id = id;
    this.borderContainer.appendChild(textElement);
  }
}
